import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private platformId = inject(PLATFORM_ID);
  private doc = inject(DOCUMENT);
  private isBrowser = isPlatformBrowser(this.platformId);

  get production(): boolean {
    return environment.production;
  }

  get urlBasePrefix(): string | null {
    return this.resolveValue(environment.urlBasePrefix);
  }

  get apiServerBase(): string | null {
    return this.resolveValue(environment.apiServerBase);
  }

  get buildDate(): string | null {
    return this.resolveValue(environment.buildDate);
  }

  get gitHash(): string | null {
    return environment.gitHash;
  }

  get googleMapsAPIKey(): string | null {
    return environment.googleMapsAPIKey;
  }

  get transactBaseUrl(): string | null {
    return environment.transactBaseUrl;
  }

  get gtm_id(): string | null {
    return environment.gtm_id;
  }
/*
  get contestLinkLabel(): string | null {
    return environment.contestLinkLabel;
  }

  get contestLinkURL(): string | null {
    return environment.contestLinkURL;
  }
*/
  get frontEndUrl(): string {
    const url = this.urlBasePrefix;
    if (this.isBrowser && url && url.indexOf('4201') > 0) {
      return url.replace('4201', '4200');
    }
    return url || '';
  }

  private resolveValue(value: string | number): string | null {
    const resolvedValue = typeof value === 'number' ? value.toString() : value;

    if (resolvedValue === 'location.origin') {
      return this.isBrowser ? window.location.origin : '';
    }

    if (resolvedValue === 'document.lastModified') {
      return this.isBrowser ? this.doc.lastModified : '';
    }

    return resolvedValue;
  }
}
